// src/components/QuizStartScreen.jsx
import React from "react";

export function QuizStartScreen({
    selectedQuiz,
    availableQuestions,   // ← new prop
    questionCount,
    setQuestionCount,
    onStart,
}) {
    const maxQuestions = availableQuestions.length;

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md space-y-6">
            <h2 className="text-xl font-bold text-gray-800">
                Start Quiz: {selectedQuiz.name}
            </h2>

            <p className="text-gray-700">
                This quiz has{" "}
                <span className="font-semibold">{maxQuestions}</span> questions.
            </p>


            <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                    How many questions would you like to answer? (Min: 5)
                </label>
                <input
                    type="number"
                    min={5}
                    max={maxQuestions}
                    value={questionCount}
                    onChange={(e) => setQuestionCount(Number(e.target.value))}
                    className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
                />
            </div>

            <button
                onClick={onStart}
                disabled={questionCount < 5 || questionCount > maxQuestions}
                className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 disabled:opacity-50 transition"
            >
                Start Quiz
            </button>
        </div>
    );
}
